import React, { useEffect, useState } from 'react';
import { fetchProducts, fetchHeroImages } from '../api';
import ProductCard from '../components/Products/ProductCard';
import { resolveImageUrl } from '../utils/imageUrl';
import './Merch.css';

const Merch = () => {
  const [products, setProducts] = useState([]);
  const [heroImages, setHeroImages] = useState([]);
  const [currentHeroIndex, setCurrentHeroIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([fetchProducts(), fetchHeroImages()])
      .then(([productsData, heroData]) => {
        const productList = Array.isArray(productsData.data) ? productsData.data : productsData;
        setProducts(productList);

        const imageList = Array.isArray(heroData.data) ? heroData.data : [];
        setHeroImages(imageList);

        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading merch data:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Auto-rotate hero images every 5 seconds
  useEffect(() => {
    if (heroImages.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentHeroIndex((prevIndex) =>
        (prevIndex + 1) % heroImages.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [heroImages]);


  if (loading) {
    return (
      <div className="merch-page">
        <div className="merch-loading-container">
          <div className="merch-loading-spinner"></div>
          <p>Loading merch...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="merch-page">
        <div className="merch-error-container">
          {/* Keeps a single h1 on the page even when the catalog fails to load. */}
          <h1 className="merch-error-title">Guhso Merch Store</h1>
          <h2>Oops! Something went wrong</h2>
          <p>Error: {error}</p>
          <button onClick={() => window.location.reload()} className="merch-retry-btn">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const currentHeroImage = heroImages.length > 0 ? heroImages[currentHeroIndex] : null;
  const heroImageUrl = resolveImageUrl(currentHeroImage?.image_url);

  return (
    <div className="merch-page">
      <div className="merch-header">
        {currentHeroImage && heroImageUrl ? (
          <div className="merch-hero-section with-image" style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '400px'
          }}>
            <h1>Guhso Merch Store</h1>
            <p>Show your support with official Guhso merchandise</p>

            {heroImages.length > 1 && (
              <div className="merch-hero-dots">
                {heroImages.map((_, index) => (
                  <button
                    key={index}
                    className={`merch-hero-dot ${index === currentHeroIndex ? 'active' : ''}`}
                    onClick={() => setCurrentHeroIndex(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="merch-hero-section">
            <h1>Guhso Merch Store</h1>
            <p>Show your support with official Guhso merchandise</p>
          </div>
        )}
      </div>

      <div className="products-container">
        {products.length === 0 ? (
          <div className="no-products">
            <h3>No products found</h3>
            <p>No products available at the moment</p>
          </div>
        ) : (
          <div className="product-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Merch;
